// src/lib/parse.js
export function toFloatLoose(v) {
  if (v === null || v === undefined) return null;
  const num = String(v).replace(/[^0-9.+-]/g, ""); // keep digits, dot, +/-; drop $, %, commas, words
  if (num === "" || num === "." || num === "+" || num === "-") return null;
  const n = parseFloat(num);
  return Number.isFinite(n) ? n : null;
}

export function toIntLoose(v) {
  if (v === null || v === undefined) return null;
  const num = String(v).replace(/[^0-9+-]/g, ""); // integers from "200 shares", "1,000", etc
  if (num === "" || num === "+" || num === "-") return null;
  const n = parseInt(num, 10);
  return Number.isFinite(n) ? n : null;
}
